/**
 * Layout
 * @module components/Layout
 */

import { Content } from './Layout.styles';
import { ReactNode } from 'react';
import clsx from 'clsx';
import { useSiteType } from 'context/siteType.context';

type LayoutProps = {
	backgroundColor?: string;
	className?: string;
	childClassName?: string;
	children: ReactNode;
};

const Layout = ({
	backgroundColor,
	className,
	children,
	childClassName,
}: LayoutProps) => {
	const siteType = useSiteType();
	return (
		<div
			className={clsx(
				'block overflow-hidden',
				backgroundColor === 'white' && siteType === 'LindabGroup'
					? 'bg-lgLightGrayBlue-imp'
					: backgroundColor
					? `bg-${backgroundColor}`
					: 'bg-transparent',
				className
			)}
		>
			<Content className={childClassName}>{children}</Content>
		</div>
	);
};

export default Layout;
